import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { FIREBASE_CONFIG } from "./app.config";

const app = initializeApp(FIREBASE_CONFIG);
export const firebaseApp = app;
export const firebaseAuth = getAuth(app);
